<template>
  <div>
    <v-reports
      v-if="access.report_receipt"
      v-model="page"
      v-bind:headers="headers"
      v-bind:update="update"
      v-bind:data="data"
      v-bind:row="row_clicked"
      v-bind:numPages="numPages"
      :data_loading="data_loading"
      @change-pagination="changePagination"
      receipt
    >
      <template #search_text_right>
        <v-btn
          v-if="access.create_reciept"
          class="mr-1"
          tile
          color="success"
          v-bind:to="'/reports/receipts/create'"
        >
          <v-icon color="white">mdi-plus</v-icon>
          <div class="text-color">
            {{ $t(`add_receipt`) }}
          </div>
        </v-btn>
      </template>
      <template #search_text>
        <v-slide-x-reverse-transition>
          <v-btn icon @click="searchActivate">
            <v-icon>mdi-magnify</v-icon>
          </v-btn>
        </v-slide-x-reverse-transition>
        <v-slide-x-reverse-transition>
          <v-text-field
            v-model="search"
            ref="search_field"
            v-if="search_text"
            :autofocus="search_field"
            class="mt-3 pa-0"
            append-icon="mdi-close"
            @click:append="
              {
                (search_text = false), (search = ''), update(params);
              }
            "
            @change="
              {
                (page = 1), update(params);
              }
            "
            :label="$t('search')"
          ></v-text-field>
        </v-slide-x-reverse-transition>
        <v-btn icon @click="downloadReceipts"
          ><v-icon>mdi-download</v-icon>
        </v-btn>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title v-if="wait">Iltimos, kutib turing!</v-card-title>
            <v-card-title v-else>Excel yuklashga tayyor!</v-card-title>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn text color="primary" @click="saveExcel" :disabled="wait">
                <export-excel :data="dovnExcel" :name="excel_name"
                  >Save Excel</export-excel
                >
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="proccesDialog" max-width="400px">
          <v-card>
            <v-list-item-action style="width: 338px; padding-left: 40px">
              <v-progress-linear
                :color="excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'"
                background-color="white"
                height="10"
                style="border: 1px solid rgba(0, 0, 0, 0.26)"
                v-bind:value="excel_dowload_proccess"
                striped
              />
              <v-list-item-action-text
                >{{ $t("download") }}
                {{ excel_dowload_proccess.toFixed() + " %" }}
              </v-list-item-action-text>
            </v-list-item-action>
          </v-card>
        </v-dialog>
      </template>

      <template #header>
        <v-tabs
          fixed-tabs
          @change="myfunc"
          v-model="mytab"
          height="100"
          icons-and-text
        >
          <v-tab>
            {{ all_receipts }} {{ $t(`all`) }}
            <v-icon x-large color="#607D8B">mdi-receipt</v-icon>
          </v-tab>
          <v-tab>
            {{ saled_receipts }} {{ $t(`sales`) }}
            <v-icon x-large color="success"
              >mdi-checkbox-multiple-marked-outline</v-icon
            >
          </v-tab>
          <v-tab>
            {{ refund_receipts }} {{ $t(`refund`) }}
            <v-icon x-large color="#E91F63">mdi-cash-refund</v-icon>
          </v-tab>
          <v-tab>
            {{ draft_receipts }} {{ $t(`draft`) }}
            <v-icon x-large color="#E91F63">mdi-file-alert-outline</v-icon>
          </v-tab>
        </v-tabs>
      </template>

      <template #drawer>
        <v-navigation-drawer
          v-model="drawer"
          right
          absolute
          :width="drawer ? 380 : 0"
        >
          <v-progress-linear
            v-if="loading_receipt"
            indeterminate
            color="primary"
          />
          <v-layout row px-4 py-2>
            <v-btn icon @click="drawer = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <!-- <v-btn v-if="current_receipt.receipt_state == 'draft'" icon color="primary" @click="editCurrentReceipt">
            <v-icon>mdi-pencil</v-icon>
          </v-btn> -->
            <v-btn
              v-if="!current_receipt.is_refund"
              icon
              color="error"
              @click="refundReceipt"
            >
              <v-icon>mdi-reply</v-icon>
            </v-btn>
            <v-menu offset-y offset-x min-width="100" max-width="100">
              <template #activator="{ on, attrs }">
                <v-btn color="#57667d" dark v-bind="attrs" v-on="on" icon>
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <v-card tile class="py-2">
                <v-btn class="mx-4 mt-1" small icon @click="downloadPdf">
                  <v-icon color="#ed3238">mdi-file-pdf-box</v-icon>
                  {{ "pdf" }}
                </v-btn>
                <v-btn
                  class="mx-8 mt-1"
                  small
                  icon
                  @click="downloadReceiptExcel"
                >
                  <v-icon color="#70f716">mdi-file-excel</v-icon>{{ "receipt" }}
                </v-btn>
                <v-btn class="mx-6 mt-1" small icon @click="createDIDOXDocument">
                  <v-icon color="#70f716">mdi-file-excel</v-icon>{{ "didox" }}
                </v-btn>
              </v-card>
            </v-menu>
            <v-menu
              v-if="current_receipt.receipt_state != 'draft'"
              offset-y
              offset-x
              min-width="160"
              max-width="160"
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  icon
                  @click="shareReceipt"
                >
                  <v-icon>mdi-share</v-icon>
                </v-btn>
              </template>
              <v-card tile class="py-2">
                <vue-yandex-share v-bind="vueYandexShareOptions" />
              </v-card>
            </v-menu>
          </v-layout>
          <hr />

          <v-layout row px-2>
            <v-flex px-2 md6 sm12 xs12>
              <v-btn
                v-if="
                  !current_receipt.user_id || current_receipt.user_id == '0'
                "
                text
                color="primary"
                @click="set_client_dialog = true"
              >
                {{ $t("set_client") }}
              </v-btn>
            </v-flex>
            <v-flex px-3 md6 sm12 xs12 class="text-right mt-2 mb-0 py-0">
              <p
                v-if="current_receipt.is_refund"
                class="red--text mb-0 py-0 body-2"
              >
                {{ $t(`refund`) }}: {{ current_receipt.receipt_no }}
              </p>
            </v-flex>
          </v-layout>

          <v-layout row px-2>
            <v-flex px-2 mx-2 md12 class="text-center mt-0 py-0">
              <p class="display-1 py-0 my-0">
                {{ current_receipt.total_price.toLocaleString() }}
              </p>
              <p class="pt-0 mt-0">{{ $t(`total`) }}</p>
            </v-flex>
          </v-layout>
          <hr class="mx-2" />
          <v-layout row px-2>
            <v-flex md12 px-2 mx-2>
              <p class="mt-2 mb-0">
                {{ $t(`cashier`) }}: {{ current_receipt.cashier_name }}
              </p>
              <p class="mt-2 mb-0" v-if="current_receipt.client_name">
                {{ $t(`client`) }}: {{ current_receipt.client_name }}
              </p>
              <p class="mt-0 mb-2">
                {{ $t(`pos`) }}: {{ current_receipt.pos_name }}
              </p>
            </v-flex>
          </v-layout>
          <hr class="mx-2" />
          <v-layout row px-2>
            <v-flex md12 pa-2 mx-2 class="mb-0">
              <p class="font-weight-bold mb-0">{{ $t(`items`) }}</p>
            </v-flex>
          </v-layout>
          <hr class="mx-2 mt-0" />

          <v-layout
            row
            px-4
            v-for="(itm, ind) in current_receipt.sold_item_list"
            :key="ind"
          >
            <v-flex md6 sm6 xs6 pa-2 class="mb-0 pb-0">
              <p class="mb-0 pb-0">{{ itm.product_name }}</p>
            </v-flex>
            <v-flex md6 sm6 xs6 pa-2 class="pb-0 mb-0 text-right">
              <p class="mb-0 pb-0">
                {{ (itm.price * itm.value).toLocaleString() }}
              </p>
            </v-flex>
            <v-flex md12 sm12 xs12 px-2 class="my-0 py-0">
              <p class="mb-0 py-0 my-0 grey--text">
                {{ itm.value }} x {{ itm.price.toLocaleString() }}
              </p>
            </v-flex>
          </v-layout>
          <hr class="mx-2 mt-2" />

          <v-layout row px-2>
            <v-flex md6 pa-2 px-4 class="mb-0 pb-0">
              <p class="mb-0 pb-0 font-weight-bold">{{ $t(`total`) }}</p>
            </v-flex>
            <v-flex md6 pa-2 px-4 class="pb-0 mb-0 text-right">
              <p class="mb-0 pb-0 font-weight-bold">
                {{ current_receipt.total_price.toLocaleString() }}
              </p>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex
              md12
              v-for="(itm, indd) in current_receipt.payment"
              :key="indd"
            >
              <v-layout row mx-2>
                <v-flex md6 pa-2 px-4 class="mb-0 pb-0 mt-2">
                  <p class="mb-0 pb-0">{{ itm.name }}</p>
                </v-flex>
                <v-flex md6 pa-2 px-4 class="pb-0 mb-0 text-right">
                  <p class="mb-0 pb-0">{{ itm.value.toLocaleString() }}</p>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>

          <v-layout row px-2>
            <v-flex md6 pa-2 px-4 class="mb-0 pb-0">
              <p class="mb-0 pb-0 font-weight-bold">{{ $t(`total_discount`) }}</p>
            </v-flex>
            <v-flex md6 pa-2 px-4 class="pb-0 mb-0 text-right">
              <p class="mb-0 pb-0 font-weight-bold">
                {{ current_receipt.total_discount.toLocaleString() }}
              </p>
            </v-flex>
          </v-layout>
          <hr class="mx-2 mt-6" />

          <v-layout row mx-2>
            <v-flex md8 pa-2 class="mb-0 pb-0">
              <p class="mb-0 pb-0 grey--text">
                {{ date_ddmmyy_hhmm(current_receipt.date) }}
              </p>
            </v-flex>
            <v-flex md4 pa-2 class="pb-0 mb-0 text-right">
              <p class="mb-0 pb-0 grey--text">
                {{ current_receipt.receipt_no }}
              </p>
            </v-flex>
          </v-layout>

          <v-layout row mx-2>
            <v-flex md8 pa-2 class="mb-0 pb-0">
              <p class="mb-0 pb-0 grey--text">
                {{ $t(`description`) }}: {{ current_receipt.comment }}
              </p>
            </v-flex>
          </v-layout>

        </v-navigation-drawer>
      </template>
    </v-reports>
    <error404 v-else></error404>

    <v-dialog v-model="set_client_dialog" :width="600">
      <v-card tile>
        <v-card-title>
          {{ $t("set_client") }}
        </v-card-title>
        <v-card-text>
          <v-autocomplete
            v-model="client_id"
            :label="$t('client')"
            v-bind:items="customers"
            item-value="user_id"
            item-text="first_name"
            v-on:update:search-input="searchCustomers"
            no-filter
            clearable
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="set_client_dialog = false">
            {{ $t("cancel") }}
          </v-btn>
          <v-btn text color="primary" @click="confirmSetClient">
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Currency from "../../mixins/settings/currency";
import Customers from "../../mixins/customer/customer";
import fileSaver from "file-saver";
import xlsx from "xlsx";
export default {
  loading: false,
  name: "ReportsReceipts",
  mixins: [Currency, Customers],
  data: () => ({
    user: {},
    drawer: false,
    headers: [
      {
        text: "Receipt no.",
        value: "receipt_no",
        available: true,
        disabled: true,
      },
      { text: "Date", value: "date", available: true },
      { text: "Store", value: "service_name", available: false },
      { text: "Cashbox", value: "pos_name", available: true },
      { text: "Employee", value: "cashier_name", available: false },
      { text: "Customer", value: "customer_name", available: false },
      { text: "Type", value: "type", available: true },
      { text: "Total", value: "total", available: true },
    ],
    data: [],
    current_receipt: {
      total_price: 0,
      total_discount: 0,
      payment: [],
    },
    dovnExcel: [],
    excel_name: "Receipt",
    dialog: false,
    all_receipts: 0,
    saled_receipts: 0,
    refund_receipts: 0,
    draft_receipts: 0,
    params: null,
    page: 1,
    numPages: 1,
    data_loading: false,
    loading_receipt: false,
    mytab: 0,
    err: null,
    shareDialog: false,
    search_field: false,
    search_text: false,
    search: "",
    // edit_current_receipt: true,
    clients: [],
    current_currency: 1,
    set_client_dialog: false,
    last_client_search: "123",
    client_id: null,
    wait: true,
    proccesDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
  }),
  updated() {
    this.vueYandexShareOptions.image = this.shareLink;
    this.vueYandexShareOptions.url = this.shareLink;
    this.vueYandexShareOptions.title = `Invan Receipt №: ${
      this.current_receipt ? this.current_receipt.receipt_no : "-1"
    }`;
  },
  watch: {
    mytab() {
      this.page = 1;
    },
    current_receipt() {
      this.vueYandexShareOptions.image = this.shareLink;
      this.vueYandexShareOptions.url = this.shareLink;
      this.vueYandexShareOptions.title = `Invan Receipt №: ${
        this.current_receipt ? this.current_receipt.receipt_no : "-1"
      }`;
    },
  },
  computed: {
    shareLink() {
      const id = this.current_receipt ? this.current_receipt._id : "noReceipts";
      return `https://api.qrserver.com/v1/create-qr-code/?size=1500x1500&data=${id}`;
    },
    items_headers() {
      return [
        { text: this.$t("item_name"), value: "product_name" },
        { text: this.$t("value"), value: "value" },
        { text: this.$t("reminder"), value: "reminder" },
        { text: this.$t("price"), value: "price" },
        { text: this.$t("total_value"), value: "total_value" },
      ];
    },
  },
  methods: {
    searchCustomers(search) {
      if (typeof search != "string") {
        search = "";
      }
      if (this.last_client_search == search) {
        return;
      }
      this.last_client_search = search;
      this.getCustomers(search);
    },
    async confirmSetClient() {
      const params = {
        receipt_id: this.current_receipt._id,
        user_id: this.client_id,
      };
      const result = this.$communicator.then(
        this,
        await this.$communicator("receipt_set_client", {
          params,
        })
      );
      if (result) {
        this.client_id = null;
        this.set_client_dialog = false;
        this.row_clicked(this.current_receipt);
      }
    },
    downloadPdf() {
      if (!this.current_receipt) {
        return;
      }
      const link = `report/receipts/pdf/${this.current_receipt._id}/${this.current_receipt.receipt_no}.pdf`;
      this.$communicator.downloadDocument(
        link,
        `${this.current_receipt.receipt_no}.pdf`
      );
    },
    async createDIDOXDocument() {
      const link = `integrations/didox/create-receipt-document/${this.current_receipt._id}`;
      const res = await this.$communicator.getRequest(link, '1.0.0');
      if(res.message === 'Success') {
        this.$toast.success("Created", { timeout: 2000 });
        return;
      }
      this.$toast.error(`Error ${res.error}`, { timeout: 2000 });
    },
    async downloadDidoxExcel() {
      const link = `inventory/didox/pdf/${this.current_receipt._id}`;
      this.$communicator.downloadDocument(
        link,
        `${this.current_receipt.receipt_no}.xls`
      );
    },
    refundReceipt() {
      this.$router
        .push(`/reports/receipts/refund?id=${this.current_receipt._id}`)
        .catch(() => {});
    },
    async downloadReceiptExcel() {
      if (!this.current_receipt) {
        return;
      }
      const link = `report/receipts/pdf/${this.current_receipt._id}/${this.current_receipt.receipt_no}?type=exel`;
      this.$communicator.downloadDocument(
        link,
        `${this.current_receipt.receipt_no}.xlsx`
      );
    },
    async downloadReceipts() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const start_date = new Date(this.params.start_date).getTime();
      const end_date = new Date(this.params.end_date).getTime();
      const limit = 1000;
      let all_data = [];
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const result = this.$communicator.then(
          this,
          await this.$communicator("by_receipt", {
            arguments: [start_date, end_date, limit, page, this.mytab],
            params: {
              custom: this.params.custom,
              start: this.params.start.time,
              end: this.params.end.time,
              services: this.params.service !== "" ? [this.params.service] : [],
              employees:
                this.params.employee._id !== ""
                  ? [this.params.employee._id]
                  : [],
              search: this.search ? this.search : "",
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...result?.receipts);
      }

      const receipts = Array(all_data.length)

      for (let i = 0; i< all_data.length; i++) {
        if(!all_data[i]){
          continue
        }

        const payments = {}
        for (const pay of all_data[i].payment) {
          if(pay.name === 'cashback') {
            payments['Given cashback'] = pay.value
            continue
          }
          payments[pay.name[0].toUpperCase() + pay.name.slice(1)] = pay.value
        }

        receipts[i] = {
          "Receipt №": all_data[i].receipt_no,
          "Payment Type": payments['Debt'] > 0 ? "Debt" : "Sale",
          Store: all_data[i].service_name,
          Pos: all_data[i].pos_name,
          Cashier: all_data[i].cashier_name,
          Customer: all_data[i].customer_name,
          INN: all_data[i].inn,
          "Total price": all_data[i].total_price,
          "Sale type": all_data[i].is_refund ? "Refund" : "Sale",
          Date: this.date_ddmmyy_hhmm(all_data[i].date),
          Comment: all_data[i].comment,
          "Used cashback": all_data[i].cash_back,
          ...payments,
        }
      }

      this.proccesDialog = false;
      const ws = xlsx.utils.json_to_sheet(receipts);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "Receipts.xlsx");
      // this.dovnExcel = await recipt;
      // setTimeout(() => (this.wait = false), 1000);
    },
    saveExcel() {
      this.dialog = false;
      this.wait = true;
    },
    searchActivate() {
      this.search_text = true;
      if (this.search_field && this.$refs["search_field"]) {
        this.$refs["search_field"].focus();
      }
      this.search_field = true;
    },
    shareReceipt() {
      this.shareDialog = true;
    },
    async row_clicked(item) {
      this.loading_receipt = true;
      try {
        const receipt = this.$communicator.then(
          this,
          await this.$communicator("receipt_by_id", {
            arguments: [item._id],
          })
        );
        if (!receipt) return;
        this.drawer = true;
        this.current_receipt = receipt;
      } catch (error) {
        this.err = error;
      }
      this.loading_receipt = false;
    },
    changePagination(page) {
      this.page = page;
      this.update(this.params);
    },
    myfunc() {
      this.page = 1;
      this.update(this.params);
    },
    async update(params) {
      const current_currency = this.current_currency;
      this.params = params;
      this.data_loading = true;
      this.params = params;
      const start_date = new Date(params.start_date).getTime();
      const end_date = new Date(params.end_date).getTime();
      let result = this.$communicator.then(
        this,
        await this.$communicator("by_receipt", {
          arguments: [start_date, end_date, 10, this.page, this.mytab],
          params: {
            custom: params.custom,
            start: params.start.time,
            end: params.end.time,
            services: params.service !== "" ? [params.service] : [],
            employees: params.employee._id !== "" ? [params.employee._id] : [],
            search: this.search ? this.search : "",
          },
        })
      );
      this.max_total = result.total;
      if (result && result.receipts instanceof Array) {
        for (const ind in result.receipts) {
          result.receipts[ind].date = this.date_ddmmyy_hhmm(
            result.receipts[ind].date
          );
          result.receipts[ind].type = result.receipts[ind].is_refund
            ? "refund"
            : "sale";
          result.receipts[ind].total = result.receipts[ind].total_price
            ? (
                Math.round(
                  result.receipts[ind].total_price * current_currency
                ) / current_currency
              ).toLocaleString()
            : result.receipts[ind].total_price;
            result.receipts[ind].payment_names = result.receipts[ind].payment.map(val => val.name).join(', ')
        }
        this.data = result.receipts;
        this.all_receipts = result.all_receipts;
        this.saled_receipts = result.sales;
        this.refund_receipts = result.refunds;
        this.draft_receipts = result.drafts;
        this.numPages = result.page;
      }
      this.data_loading = false;
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
  mounted() {
    this.get_currency();
    this.getCustomers("");
    this.current_currency = this.currentCurrency === "usd" ? 100 : 1;
    this.headers = [
      {
        text: this.$t(`receipt_no`),
        value: "receipt_no",
        available: true,
        disabled: true,
      },
      { text: this.$t(`date`), value: "date", available: true },
      { text: this.$t(`payment_types`), value: "payment_names", available: true },
      { text: this.$t(`store`), value: "service_name", available: true },
      { text: this.$t(`cashbox`), value: "pos_name", available: true },
      { text: this.$t(`employee`), value: "cashier_name", available: false },
      { text: this.$t(`customer`), value: "customer_name", available: false },
      { text: this.$t(`type`), value: "type", available: true },
      { text: this.$t(`total`), value: "total", available: true },
    ];
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.user = this.$store.state.user;
    if (this.$route && this.$route.query && this.$route.query.id) {
      this.row_clicked({ _id: this.$route.query.id });
    }
  },
};
</script>
<style scoped>
.text {
  color: lightgrey;
  text-decoration-color: lightgrey;
}
</style>
